import { TranslationService } from '@/utils/services/TranslationService';

import { useProfileHasAccessPage } from '@/utils/hooks/acl/useProfileHasAccessPage';
import useDisplayFirstStatsPanel from '@/utils/hooks/firstStats/useDisplayFirstStatsPanel';

import { MANAGE_COMMENTS_TRACKER } from '@/lib/routes/privateRoutes';

import { HeaderConversations } from '@/components/layouts/wrappers/ConversationsWrapper/HeaderConversations';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import { SocialInbox } from '@/components/pages/conversations/SocialInbox/SocialInbox';

const Comments = () => {
    const { hideFirstStatsEmptyState } = useDisplayFirstStatsPanel();

    const {
        activeSocialProfileNoAccess,
        activeGroupNoAccess,
        activeMultiSelectionProfilesNoAccess
    } = useProfileHasAccessPage();

    return (
        <WrapperSwitchLayout
            disableMainScroll={
                !activeSocialProfileNoAccess &&
                !activeGroupNoAccess &&
                !activeMultiSelectionProfilesNoAccess &&
                hideFirstStatsEmptyState
            }
            noPadding={true}
            className="px-5 py-5 pb-10 sm:px-8 sm:pb-0 sm:pt-8">
            <>
                <HeaderConversations />
                <SocialInbox />
            </>
        </WrapperSwitchLayout>
    );
};

export const getStaticProps =
    TranslationService.getTranslationMessagesFromRoute(MANAGE_COMMENTS_TRACKER);

export default Comments;
